













































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { formatMoney, objectify } from "@/helpers";
// @ts-ignore
import { VueFunnelGraph } from "vue-funnel-graph-js";
import PerformanceIcon from "./PerformanceIcon.vue";
import moment from "moment";
import featureConfigs from "@/helpers/featureConfigs";

@Component({
  components: {
    VueFunnelGraph,
    PerformanceIcon
  }
})
export default class PerformanceOverviewCard extends Vue {
  @Prop({ default: {} }) dashboardStats!: any;
  @Prop({ required: true }) getAllMetrics!: Function;
  @Prop({ required: true }) metricsFilter!: any;
  @Prop({ default: [], required: true }) metrics!: any[];
  @Prop({ required: true }) isAdmin!: boolean;
  @Prop({ default: [], required: true }) agentsEmails!: any[];

  isFunnelVisible = false;
  labels = ["Total Calls", "Call Time > 5m", "On Holds", "Cleared Sales"];
  colors = ["#739CA7", "#294F72"];
  direction = "horizontal";
  gradientDirection = "horizontal";
  height = 300;
  width = 800;
  resizeTimeout = null;
  targets: any = null;

  @Watch("metricsFilter", { deep: true })
  onFilterChange(metricsFilter: any) {
    if (
      Array.isArray(metricsFilter.dates) &&
      metricsFilter.dates.length === 2
    ) {
      this.getAllMetrics(metricsFilter.dates[0], metricsFilter.dates[1]);
    }
  }

  get filterMetricDateText() {
    return `${moment(this.metricsFilter.dates[0]).format(
      "MMM DD, YYYY"
    )} ~ ${moment(this.metricsFilter.dates[1]).format("MMM DD, YYYY")}`;
  }

  getPerformanceIcon(performanceValue: number, performanceKey: string) {
    if (this.targets) {
      const performanceHigh = this.targets[performanceKey].high;
      const performanceLow = this.targets[performanceKey].low;

      if (performanceValue / 100 >= performanceHigh) {
        return "high";
      }

      if (performanceValue / 100 <= performanceLow) {
        return "low";
      }

      return "mid";
    }
  }

  getPerformance(performanceValue: number, performanceKey: string) {
    if (this.targets) {
      const performanceHigh = this.targets[performanceKey].high;
      const performanceLow = this.targets[performanceKey].low;

      if (performanceValue / 100 >= performanceHigh) {
        return `Above target of ${performanceHigh * 100}%`;
      }

      if (performanceValue / 100 <= performanceLow) {
        return `Below target of ${performanceLow * 100}%`;
      }

      return `Between target range`;
    }
  }

  getPercentage(partialValue: number, totalValue: number) {
    return Math.floor((100 * partialValue) / totalValue) || 0;
  }

  mounted() {
    const configs = featureConfigs.getGroup("fronter_t1");

    this.targets = configs.targets;

    this.isFunnelVisible =
      // @ts-ignore
      this.$refs.wrapper && this.$refs.wrapper.offsetWidth > 0;
    window.addEventListener("resize", this.handleResize);
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  }

  get getMinDate() {
    return null;
  }

  get getMaxDate() {
    return moment().format("YYYY-MM-DD");
  }

  handleResize() {
    // @ts-ignore
    if (this.resizeTimeout) clearTimeout(this.resizeTimeout);
    // @ts-ignore
    this.resizeTimeout = setTimeout(() => {
      this.isFunnelVisible = false;
      this.$nextTick(() => {
        this.isFunnelVisible = true;
      });
    }, 200);
  }
}
